import api from "utils/api";

// Get all raise invoices with filters
export const getAllRaiseInvoices = async (params = {}) => {
  try {
    const response = await api.get("/finance/get-all-raise-invoice", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all tutor payment cycles
export const getAllTutorPaymentCycles = async (params = {}) => {
  try {
    const response = await api.get("/tutor-payment-cycles", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get single tutor payment cycle by ID
export const getTutorPaymentCycleById = async (id) => {
  try {
    const response = await api.get(`/tutor-payment-cycles/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all cycles for a specific tutor
export const getAllCyclesForTutor = async (tutorId) => {
  try {
    const response = await api.get("/tutor-payment-cycles", {
      params: { tutorId, limit: 100 },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get income breakdown
export const getIncomeBreakdown = async (params = {}) => {
  try {
    const response = await api.get("/finance/income-breakdown", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get revenue snapshot
export const getRevenueSnapshot = async () => {
  try {
    const response = await api.get("/finance/revenue-snapshot");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getDashboardPaymentSummary = async () => {
  try {
    const response = await api.get("/finance/dashboard-payment-summary");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getFinancialComparison = async (params = {}) => {
  try {
    const response = await api.get("/finance/financial-comparison", {
      params,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update tutor payment cycle status
export const updateTutorPaymentCycleStatus = async (id, data) => {
  try {
    const response = await api.put(`/tutor-payment-cycles/${id}/status`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get income over time data
export const getIncomeOverTime = async (params = {}) => {
  try {
    const response = await api.get("/finance/income-over-time", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getActivationRenewalSummary = async (params = {}) => {
  try {
    const response = await api.get("/finance/activation-renewal-summary", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
